import { DateTime } from 'luxon';

// capitalize and place line breaks before logical operators
export const formatConditionString = (str: string) => str.replace(/(\r\n|\n|\r)/gm, '').replace(/\s+or\s+(?=[^"']*(?:["'][^"']*["'][^"']*)*$)/gi, '\n OR ').replace(/\s+and\s+(?=[^"']*(?:["'][^"']*["'][^"']*)*$)/gi, '\n AND ').replace(/[\s+]not\s+(?=[^"']*(?:["'][^"']*["'][^"']*)*$)/gi, ' NOT ');

export const dateTimeFormatter = (dateTimeStr: string): string => {
  const zone = DateTime.fromISO(dateTimeStr).zoneName;
  const dt = DateTime.fromISO(dateTimeStr, { zone }).toUTC();
  const dtStr = dt.toLocaleString({ ...DateTime.DATETIME_FULL_WITH_SECONDS, weekday: 'short' });
  return dtStr;
};
